import * as React from "react"
import { NavItem, NavLink } from "shards-react"

const SocialMediaIcon = props => (
  <NavItem>
    <NavLink target="_blank" href={props.href}>
      <div dangerouslySetInnerHTML={{ __html: props.icon }} />
    </NavLink>
  </NavItem>
)

export default SocialMediaIcon
